/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 
import "./fin-page-footer.js";
const template = html `
<custom-style>
  <style include="login-styles">
    :dir(ltr) .message {
      margin-left: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-right: 4%; */
    }
	
	:dir(rtl) .message {
      margin-right: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-left: 4%; */
    }
	
	.stealthy{
				display: none;
                left: 0;
                margin: 0;
                max-height: 1px;
                max-width: 1px;
                opacity: 0;
                outline: none;
                overflow: hidden;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: -1;
            }
    .align-ev-input {
      text-align:left;
      margin-left:16px;
      margin-right:16px;
    }
		:dir(rtl) .stealthy{
			display: none;
			right: 0;
			left: auto;
			margin: 0;
			max-height: 1px;
			max-width: 1px;
			opacity: 0;
			outline: none;
			overflow: hidden;
			pointer-events: none;
			position: absolute;
			top: 0;
			z-index: -1;
        }
    	@media all and (-ms-high-contrast:none)
      	{
		oe-input {
          		--paper-input-container-label: {
              			top: -4px;
            		}
          	}
      	}
          app-dialog{
              --iron-input: {
                display:none !important;
              }
          }

          .center-image{
			  margin-left: 30%;
		  }
          .imgstyle{
              height:50px;
              width:100px;
          }
          .descriptionStyle{
            border: 2px solid teal;
            padding: 2px 8px 2px 7px;
            border-radius: 20px;
          }
          .iron-icon-terms{
            height: 30px;
            width: 30px;
          }
          .font30{
            font-size: 30px;
          }
          .font25{
            font-size: 25px;
          }
          .imgstyle{
            height: 188px;
            width: 200px;
          }
          .wid10{
            width:10%;
          }
          .wid80{
            width:80%;
          }
  </style>
  </custom-style>  
  <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
  <div id="main-container" class="full-height light-background">
    <template is="dom-if" if="{{!phone}}">
      <div class="mdl-grid " style="border-bottom:2px solid #dbdfe8;padding: 35px 15px 20px 15px;" >
          <div class="mdl-cell mdl-cell--2-col">
          </div>
          <div class="layout mdl-cell mdl-cell--8-col vertical">
              <div class="content-align-center font30 font-weight-bold mdl-cell mdl-cell--12-col">
                  <oe-i18n-msg msgid="l_registrationSucess"></oe-i18n-msg>
              </div> 
          </div>
          <div class="content-align-horizontal-end mdl-cell mdl-cell--2-col">
              <iron-icon class="iron-icon-style-l" on-tap="_loginAgain" style="color: teal;" icon="close"></iron-icon>
          </div>
      </div>
    </template>
    <template is="dom-if" if="{{phone}}">
      <div class=" ">
        <div class="horizontal layout content-align-vertical-center">
          <div class="wid10" style="margin-top: 10%;">
          </div>
          <div class="wid80" style="margin-top: 10%;">
              <oe-i18n-msg class="content-align-center font25 font-weight-bold" msgid="l_registrationSucess"></oe-i18n-msg>
          </div> 
          <div class="content-align-horizontal-end wid10" style="margin-top: 10%;">
              <iron-icon class="iron-icon-style-l" on-tap="_loginAgain" style="color: teal;" icon="close"></iron-icon>
          </div>
        </div>
      </div>
    </template>
    <div>
        <div class="mdl-cell mdl-cell--12-col  vertical margin-b-zero" style="padding: 25px;">
            <div  class=" content-align-center">
                <img src="node_modules/speedboat_ui/images/NBB/AllSetRegisteration.jpg" class="imgstyle">
            </div>
            <div  class="content-align-center mdl-cell mdl-cell--12-col" style="padding: 10px 0px;">
                <oe-i18n-msg class="font-18 mdl-cell--5-col" msgid="l_registeredSuccessfullNote" style="text-align: center;"></oe-i18n-msg>
            </div>
            <div class="content-align-center mdl-cell mdl-cell--12-col" style="padding: 15px 0px;">
                <paper-button class="mdl-cell--3-col primary-button text-transform-capitalize" on-tap="_loginAgain" style="
                height: 40px;">
					 <oe-i18n-msg msgid="b_login"></oe-i18n-msg>
				</paper-button>
            </div>
        </div>
    </div>
    <div class="">
        <div class=" light-background" style="height: 30%;padding-left: 3%;">
            <!--<div class="content-align-center font-16 mdl-cell mdl-cell--12-col teal-color" style="padding-top: 2%;" on-tap="resetMpinFunction">
                <oe-i18n-msg msgid="l_resetMpinAndAdvancedSecurityOptions" class="cursor-pointer" style="text-decoration: underline;"></oe-i18n-msg>
            </div>-->
        </div>
        <div class="mdl-cell--12-col mdl-grid light-background"></div>
        <!-- component for the footer -->
        <fin-page-footer/>
    </div>
  </div> 

  `;
Polymer({
    is: 'fin-auth-qr-success',
    _template: template,
    properties: {
        wrapperValue: {
            type: String,
            value: '',
            notify: true
        },
        showError: {
            type: Boolean,
            value: false,
            notify: true,
            observer: "toggleErrorMessage"
        },
        errorMessage: {
            type: String,
            value: "Minimum 6 and maximum 12 characters",
            notify: false
            },
        showCrontoImageFlag: {
            type: Boolean,
            value: false,
            notify: true
        },
        selectedFlag: {
            type: Boolean,
            notify: true,
            value: false
        },
        selectedLoginPage:{
            type:Number,
            notify:true 
        },
        selectedPage: {
            type: Number,
            notify: true 
        },
        crontoResponse: {
            type: Object,
            notify: true,
            observer:'_setCrontoData'
        },
        crontoData:{
            type: String,
            value: '',
            notify: true,
        },
        dataBody:{
            type: Object,
            notify: true
        },
        fromQrSuccess:{
            type: Boolean,
            notify: true,
            value: false
        },
        redirectUrl: {
            type: String,
            notify: true,
            value: ""
          }
    },
    ready: function() { 
    },
    attached: function() { 
        
  },
  gotologinPage(){
    this.selectedLoginPage=0;
    this.fromQrSuccess=true;
    this.selectedPage=0;
    
  },
  _loginAgain: function () { 
      var mainbody = document.getElementById("mainbody");
      var role = mainbody.role;
      const tenantID = sbEncrypt.decrypt(window.tenantId);
      window.tenantId = "";
  
      if (window.location.protocol == 'file:') {
        if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
          this.redirectUrl = localStorage.uibaseroute + "/index.html";
          localStorage.tenantId = "";
        } else if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
          this.redirectUrl = localStorage.uibaseroute + "/indexAdmin.html";
        }
      } else {
        if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
          this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + tenantID; // clear tenant id from localstorage
  
          localStorage.tenantId = "";
        } else if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
          this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + tenantID + "/indexAdmin.html";
        } else if (role === "admin") {
          this.redirectUrl = "?bank_id=" + tenantID + "/admin";
        } else {
          this.redirectUrl = "?bank_id=" + tenantID;
        }
      }
  
      location.href = this.redirectUrl;
  
      if (typeof routerPolicy != "undefined" && routerPolicy.decideNavigation) {
        routerPolicy.decideNavigation({
          url: '/login'
        }, function (e) {}, function (e) {});
      } 
  }
});